export const setRouteNames = (route) => {
  sessionStorage.setItem('DRCNET_ROUTE_NAME', JSON.stringify(route));
};

export const getRouteNames = () => {
  const names = sessionStorage.getItem('DRCNET_ROUTE_NAME');
  if (!names) return [];
  return JSON.parse(names);
};

export const setRouteStorage = (route) => {
  sessionStorage.setItem('DRCNET_ROUTE', JSON.stringify(route));
};

export const getRouteStorage = () => {
  const route = sessionStorage.getItem('DRCNET_ROUTE');
  if (!route) return {};
  return JSON.parse(route);
};

export const setUserToken = (token) => {
  sessionStorage.setItem('DRCNET_TOKEN', token);
};

export const getUserToken = () => {
  const result = sessionStorage.getItem('DRCNET_TOKEN');
  if (!result) return null;
  return result;
};
